module.exports = __webpack_public_path__ + "assets/img/6.51352a07.jpg";